import defaultConfig from '../config/defaultConfig.json';

export const generateTheme = (hostConfig) => ({
  ...defaultConfig,
  ...hostConfig,
  palette: {
    ...defaultConfig.commonPalette,
    ...defaultConfig.palette,
    ...(hostConfig && hostConfig.commonPalette ? hostConfig.commonPalette : {}),
    ...(hostConfig && hostConfig.palette ? hostConfig.palette : {}),
  },
  darkPalette: {
    ...defaultConfig.commonPalette,
    ...defaultConfig.darkPalette,
    ...(hostConfig && hostConfig.commonPalette ? hostConfig.commonPalette : {}),
    ...(hostConfig && hostConfig.darkPalette ? hostConfig.darkPalette : {}),
  },
  features: {
    ...defaultConfig.features,
    ...(hostConfig ? hostConfig.features : {}),
  },
});
